import styled from "styled-components";
import { Rounded } from "../theme/Rounded";
import { Flex } from "./Flex";

export const UserProfileWrapper = styled(Flex)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${Rounded.circle};
  border: ${({ theme }) => `2px solid ${theme.sub}`};
  width: 2.75rem;
  height: 2.75rem;
  overflow: hidden;
  cursor: pointer;

  svg {
    width: 100%;
    height: 100%;
  }
`;
